import { produce } from 'immer'
import type { State } from '../typings'

export type OpenDialogAction = {
  type: 'openDialog'
  payload: State['activeDialog']
}

export const openDialogProducer = produce<
  State,
  [payload: OpenDialogAction['payload']]
>((draft, payload) => {
  draft.activeDialog = payload
})

export const openDialogActionCreator = (
  payload: OpenDialogAction['payload'],
): OpenDialogAction => ({
  type: 'openDialog',
  payload,
})
